import { useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { token, removeToken } = useAuth();
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    const validateToken = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/check_token`, {
          headers: {
            Authorization: "Bearer " + token,
          },
        });

        if (!res.ok) throw new Error("Invalid token");

        setIsValid(true);
      } catch (err) {
        removeToken();
        setIsValid(false);
      }
    };

    if (token) {
      validateToken();
    } else {
      setIsValid(false);
    }
  }, [token, removeToken]);

  if (isValid === null) return null;
  if (!isValid) return <Navigate to="/login" />;
  return children;
};

export default ProtectedRoute;
